module.exports = __webpack_public_path__ + "media/newstyle/images/lock-7b936d4928fcb422c308f5de64fb8e6a.svg";